import React, { useReducer, useEffect } from 'react';
import CustomTextField from '../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { Button } from '@material-ui/core';
import { saveOrUpdateRoomConfigs } from '../../../utils/IntegrationsAPIUtils';
import { notificationManager } from '../../../utils/NotificationUtils';
import {
  fetchGRERoomList,
  fetchSelectedRoom,
  vendorsSelector,
} from '../../../layouts/configurations/configurationSlice';
import { useDispatch, useSelector } from 'react-redux';
import { selectedHotelSelector } from '../../../layouts/property/propertySlice';
import { formDataValidate } from '../../../utils/formUtils';
import { GRE_MULTI_LIST } from '../../../constants/restaurantConst';
import CustomSelect from '../../../shared/form-controls/custom-select/Custom-Select';
import CustomMultiSelect from '../../../shared/form-controls/custom-multi-select/Custom-Multi-Select';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../utils/loaderSlice';

const GuestRoomExperienceRoomTabMMR = (props) => {
  const { mmrInfo, roomId, showLoader = () => {} } = props;
  const selectedHotel = useSelector(selectedHotelSelector);
  const dispatch = useDispatch();
  const allVendors = useSelector(vendorsSelector);
  const { MMR } = allVendors;
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    code: {
      value: '',
      fieldName: 'MMR Code',
      errors: {},
      validations: [],
    },
    provider: {
      value: '',
      fieldName: 'MMR Provider',
      errors: {},
      validations: [],
    },
    protocol: {
      value: '',
      fieldName: 'MMR Protocol',
      errors: {},
      validations: [],
    },
    id: {
      value: '',
      fieldName: 'ID',
      errors: {},
      validations: ['required'],
    },
  });

  useEffect(() => {
    if (mmrInfo) {
      const currFields = { ...formData };
      for (let field in currFields) {
        currFields[field].value = mmrInfo[field];
      }
      setFormData(currFields);
    }
  }, [mmrInfo]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      try {
        const payload = {};
        dispatch(stepUpLoaderCount());
        for (let field in formData) {
          payload[field] = formData[field].value;
        }

        await saveOrUpdateRoomConfigs(selectedHotel, roomId, 'MMR', payload);
        notificationManager('success', 'MMR details saved successfully');
        dispatch(fetchGRERoomList(selectedHotel));
        dispatch(fetchSelectedRoom(selectedHotel, roomId));
      } catch (error) {
        if (error?.message) {
          notificationManager('danger', error?.message);
        } else {
          notificationManager('danger', 'MMR details save failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
  };

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  return (
    <form className='global-tab' noValidate onSubmit={handleSubmit}>
      <div className='container px-0 d-flex align-items-end flex-column h-100'>
        <div className='row w-100 d-flex mt-2'>
          <div className='row'>
            <div className='col-md-4 mb-3'>
              <CustomTextField
                item={formData?.code}
                handleInputChange={(e) => {
                  setFormData({ code: e });
                }}
              />
            </div>
            <div className='col-md-4 mb-3'>
              <CustomSelect
                item={formData.provider}
                handleInputChange={(e) => {
                  setFormData({ provider: e });
                }}
                options={MMR}
                labelField='name'
                valueField='id'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4 mb-3'>
              <CustomMultiSelect
                item={formData.protocol}
                handleInputChange={(e) => {
                  setFormData({ protocol: e });
                }}
                options={GRE_MULTI_LIST}
                labelField='name'
                valueField='id'
              />
            </div>
            <div className='col-md-4 mb-3'>
              <CustomTextField
                item={formData.id}
                handleInputChange={(e) => {
                  setFormData({ id: e });
                }}
              />
            </div>
          </div>
        </div>
        <div className='row d-flex mt-auto w-100 pb-4'>
          <div>
            <Button size='large' variant='contained' color='primary' className='me-3' type='submit'>
              Save
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default GuestRoomExperienceRoomTabMMR;
